import {
  Box,
  Grid
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BasicDetails, About, ProfileBoard, ChangeTeamModal } from "./Index";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useParams } from "react-router-dom";
import profilebg from "../../../assets/profile.jpg"
import "./Myaccount.css";
import {
  StencilList,
} from "react-placemoulder";
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from "react-redux";
import { profile_details } from "../../../redux/actions/user.actions"
import { CustomizedSnackbar } from '../../../shared/index';
import TeamMemberOrgChart from './TeamMemberOrgChart';
import { CommonModal } from "../../../shared";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Details = styled(Paper)(({ theme }) => ({
  // backgroundColor: "#4da6ff",
  height: 115,
  // color: "white",
}));

function MyAccount() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isMyAccount, setIsMAccount] = useState(true)
  const [detailsLoading, setDetailsLoading] = useState(true)
  const [aboutLoading, setAboutLoading] = useState(true)
  const [basicdetailLoading, setBasicDetailLoading] = useState(true)
  const { id } = useParams()
  const [userId, setUserId] = useState(id ? id : "")
  const [pathname, setPathname] = useState(window.location.pathname)
  const [teamMember, setTeamMember] = useState([])
  const [teamMemCount, setTeamMemberCount] = useState(0)
  const [isManager, setIsManager] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [openReprt, setOpenReprt] = React.useState(false);

  const [userDetails, setUserDetails] = useState({
    profile:
    {
      empNumber: 5,
      firstName: "Sundaresh",
      lastName: "Perumal",
      emailId: "sundaresh@aggregateintelligence.in",
      departmentName: "New Projects Team",
      jobTitle: "Technical Lead",
      profilePhotoName: "",
      description: "dummy text"
    }

  })
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";

  var emplyDetails = useSelector(state => state.empDetails.employeeDetails);
  var isManagerUpdate = useSelector(state => state.managerUpdate_Reducer.manager);

  useEffect(() => {
    window.scrollTo(0, 0)
    setOpenReprt(false)
    setModalOpen(false)
    // isManagerUpdate="";
  }, [])

  useEffect(() => {
    if (emplyDetails !== undefined) {
      setAboutLoading(false)
      setDetailsLoading(false)
      setBasicDetailLoading(false)
      if (emplyDetails.profile !== undefined) {
        var count = 0;
        setUserDetails(emplyDetails.profile)
        setTeamMember(emplyDetails.profile.teamMembers)
        setIsManager(emplyDetails.profile.profile.isManager)
        emplyDetails.profile.teamMembers.filter((parent) => {
          if (parent.id === parseInt(userId)) {
            var parentId = parent.id
            emplyDetails.profile.teamMembers.filter((parent) => {
              if (parent.parent === parentId) {
                count = count + 1;
              }
            })
          }
        })
        setTeamMemberCount(count)
      }
    }
  }, [emplyDetails])

  // useEffect(()=>{
  //   if(isManagerUpdate.data ==="success"){
  //     setModalOpen(false)

  //   }
  // },[isManagerUpdate])

  useEffect(() => {
    setTeamMember([])
    if (window.location.pathname.includes("/myaccount")) {
      setUserDetails({
        profile:
        {
          empNumber: 5,
          firstName: "Sundaresh",
          lastName: "Perumal",
          emailId: "sundaresh@aggregateintelligence.in",
          departmentName: "New Projects Team",
          jobTitle: "Technical Lead",
          profilePhotoName: "",
          description: "dummy text"
        }
      })
      setAboutLoading(true)
      setDetailsLoading(true)
      setBasicDetailLoading(true)
      setIsMAccount(true)
      setUserId(isUserLogged.userid)
      dispatch(profile_details(isUserLogged.userid))
      // profileDetails(isUserLogged.userid)
    }
    if (window.location.pathname.includes("/users-profile")) {
      setUserDetails({
        profile:
        {
          empNumber: 5,
          firstName: "Sundaresh",
          lastName: "Perumal",
          emailId: "sundaresh@aggregateintelligence.in",
          departmentName: "New Projects Team",
          jobTitle: "Technical Lead",
          profilePhotoName: "",
          description: "dummy text"
        }
      })
      setAboutLoading(true)
      setDetailsLoading(true)
      setBasicDetailLoading(true)

      setIsMAccount(false)
      if (id !== undefined) {
        dispatch(profile_details(id))
        // profileDetails(userId)
        setUserId(id)
      }

    }
  }, [window.location.pathname])


  const profileDetails = (id) => {
    axiosFetch({
      method: 'GET',
      url: `/employees/profile/${id}`
    })
      .then((res) => {
        if (res.status === 200) {
          setAboutLoading(false)
          setDetailsLoading(false)
          setBasicDetailLoading(false)
          setUserDetails(res.data.profile)
          setTeamMember(res.data.profile.teamMembers)
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleManager = (event) => {
    // setIsManager(event.target.checked)
    var req = {
      "userId": userId,
      "isManager": event.target.checked
    }
    if (isManager && teamMemCount > 0) {
      handlePopup()
    }
    else {
      handleCommonPopup()
    }
  }

  const handlePopup = () => {
    if (modalOpen) {
      setModalOpen(false)
    }
    else {
      setModalOpen(true)
    }
  }

  const handleCommonPopup = () => {
    if (openReprt) {
      setOpenReprt(false)
    }
    else {
      setOpenReprt(true)
    }
  }

  return (
    <div className="argus-user-profile" data-testid="my-account">
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isMyAccount ?
              <h1 data-testid="loggedInuserProfile" className="main-heading">My Account</h1> : ""
            }
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <Grid container spacing={1} columns={6}>
              <Grid item xs={6} className="argus-profile-box">
                <Details
                  className="avtar-bg"
                  style={{
                    width: "100%",
                    backgroundColor: "transparent",
                    backgroundImage: "url(" + profilebg + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "100% 90%"
                  }}
                >
                  {detailsLoading ? (
                    <StencilList
                      length={1}
                      Component={ProfileBoard}
                      data={userDetails}
                    />
                  ) : (
                    <ProfileBoard {...userDetails} Id={userId} />
                  )}
                </Details>
              </Grid>
              <Grid item xs={6}>
                <Item className="box-shadow" sx={{ marginBottom: "2px" }}>
                  {basicdetailLoading ? (
                    <StencilList length={1} Component={BasicDetails} data={userDetails} />
                  ) : (
                    <BasicDetails {...userDetails} Id={userId} count={teamMemCount} isManager={isManager} />
                  )}
                </Item>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6} sx={{paddingTop: "0px !important"}}>
            <Grid container spacing={1} columns={6}>
              <Grid item xs={6}>
                <Item className="box-shadow" sx={{ marginBottom: "2px" }}>
                  {aboutLoading ? (
                    <StencilList length={1} Component={About} data={userDetails} />
                  ) : (
                    <About {...userDetails} Id={userId} />
                  )}
                </Item>
              </Grid>

              <Grid item xs={12} md={6} lg={6} xl={6}>
                {teamMember.length > 0 ? <Item className="box-shadow">
                  <h3 className="about-me" style={{ margin: "10px 0", padding: "0 5px" }}>
                    Organization Structure
                  </h3>
                  <TeamMemberOrgChart TeamMembers={teamMember} />
                </Item> : ""}</Grid>
            </Grid>
          </Grid>
        </Grid>


      </Box>
      {basicdetailLoading ? "" :
        <ChangeTeamModal open={modalOpen} handleClick={handlePopup} pageData={userDetails.profile} count={teamMemCount} />}
      {/* <CommonModal module="ChangeManagerConfirmation" Id={userId} openModal={openReprt} handlepopupState={handleCommonPopup} manager={isManager} count={teamMemCount} /> */}
      <CustomizedSnackbar />
    </div>
  );
}
export default MyAccount;
